import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { initialState, markLocalSearch } from "stores/local-search/localSearchSlice";

//Use the `useClearSearch` hook, when the user clicks the 'Clear all' button or the close button on the drawer footer
const useClearSearch = () => {
  const dispatch = useDispatch();
  return useCallback(() => {
    dispatch(markLocalSearch({
      ...initialState,
      guestDetails: {
        ...initialState.guestDetails,
        adultCount: 0
      }
    }));
  }, [dispatch]);
};
export default useClearSearch;